import { TKey } from "@/app/translations/TKey";
import { FAQKeys } from "@/app/types/common/FAQKeys";

export const MEIDLY_FAQ: FAQKeys = {
  supTitle: TKey.FAQ,
  title: TKey.FAQ_TITLE,
  items: [
    {
      titleKey: TKey.FAQ_MEIDLY_1_TITLE,
      descriptionKeys: [TKey.FAQ_MEIDLY_1_TEXT, TKey.FAQ_MEIDLY_1_TEXT_2],
    },
    {
      titleKey: TKey.FAQ_MEIDLY_2_TITLE,
      descriptionKeys: [TKey.FAQ_MEIDLY_2_TEXT, TKey.FAQ_MEIDLY_2_TEXT_2, TKey.FAQ_MEIDLY_2_TEXT_3],
    },
    {
      titleKey: TKey.FAQ_MEIDLY_3_TITLE,
      descriptionKeys: [TKey.FAQ_MEIDLY_3_TEXT, TKey.FAQ_MEIDLY_3_TEXT_2, TKey.FAQ_MEIDLY_3_TEXT_3],
    },
    {
      titleKey: TKey.FAQ_MEIDLY_4_TITLE,
      descriptionKeys: [TKey.FAQ_MEIDLY_4_TEXT, TKey.FAQ_MEIDLY_4_TEXT_2, TKey.FAQ_MEIDLY_4_TEXT_3],
    },
    {
      titleKey: TKey.FAQ_MEIDLY_5_TITLE,
      descriptionKeys: [TKey.FAQ_MEIDLY_5_TEXT, TKey.FAQ_MEIDLY_5_TEXT_2],
    },
    {
      titleKey: TKey.FAQ_MEIDLY_6_TITLE,
      descriptionKeys: [TKey.FAQ_MEIDLY_6_TEXT, TKey.FAQ_MEIDLY_6_TEXT_2],
    },
    {
      titleKey: TKey.FAQ_MEIDLY_7_TITLE,
      descriptionKeys: [TKey.FAQ_MEIDLY_7_TEXT, TKey.FAQ_MEIDLY_7_TEXT_2],
    },
    { titleKey: TKey.FAQ_MORE_TITLE, descriptionKeys: [TKey.FAQ_MORE_TEXT] },
  ],
};
